import { animate, state, style, transition, trigger } from '@angular/animations';

export const transitionNewWidthInOut = trigger(
  'transitionNewWidthInOut', [
  transition(':enter', [
    style({ width: '0' }),
    animate('.2s ease-out', style({ width: '450px' })),
  ]),
  transition(':leave', [
    style({ width: '450px' }),
    animate('.2s ease-out', style({ width: '0' })),
  ]),
]);
export const transitionNewHeightInOut = trigger(
  'transitionNewHeightInOut', [
  transition(':enter', [
    style({ height: '0' }),
    animate('.2s ease-out', style({ height: '293px' })),
  ]),
  transition(':leave', [
    style({ height: '293px' }),
    animate('.2s ease-out', style({ height: '0' })),
  ]),
]);
export const transitionNewRowInOut = trigger(
  'transitionNewRowInOut', [
  transition(':enter', [
    style({ height: '0' }),
    animate('.15s ease-out', style({ height: '71px' })),
  ]),
  transition(':leave', [
    style({ height: '71px' }),
    animate('.15s ease-out', style({ height: '0' })),
  ])
]);

export const tableRowAnimation = trigger('tableRowAnimation', [
  state('void', style({ opacity: 0 })),
  transition(':enter', [
    style({ opacity: 0 }),
    animate('300ms ease-out', style({ opacity: 1 })),
  ]),
]);

export const appearHeight = trigger(
    'appearHeight', [
      transition(':enter', [
        style({ height: '0px', opacity: 0 }),
        animate('.2s ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('.3s ease-out', style({ height: '0px', opacity: 0 }))
      ])
    ]
);

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate('.2s ease-in', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('.2s ease-out', style({ opacity: 0 }))]),
]);

export const appearWidth = trigger('appearWidth', [
  transition(':enter', [style({ opacity: 0 }), animate('.2s ease-out', style({ opacity: 1 }))]),
  transition(':leave', [style({ maxWidth: '300px', opacity: 1 }), animate('.4s ease-out', style({ maxWidth: 0, opacity: 0 }))]),
]);

// Subtle slide-in from above — for sidebar list items
export const appearFromAbove = trigger('appearFromAbove', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(-12px)',
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      overflow: 'hidden'
    }),
    animate('.2s cubic-bezier(0.4, 0, 0.2, 1)', style({
      opacity: 1,
      transform: 'translateY(0)',
      height: '*',
      paddingTop: '*',
      paddingBottom: '*'
    }))
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate('.2s cubic-bezier(0.4, 0, 1, 1)', style({
      opacity: 0,
      transform: 'translateY(-12px)',
      height: 0,
      paddingTop: 0,
      paddingBottom: 0
    }))
  ])
]);
